export const BROLL_IMAGES = [
  { url: "https://images.unsplash.com/photo-1747572939290-50c62611ee1c?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["phone", "screen", "app", "video"] },
  { url: "https://images.unsplash.com/photo-1759393852314-59dc00faeed3?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["creator", "filming", "tripod", "content"] },
  { url: "https://images.unsplash.com/photo-1557515126-1bf9ada5cb93?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["city", "night", "aerial", "skyline"] },
  { url: "https://images.unsplash.com/photo-1671877321315-e114825a475c?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["city", "aerial", "traffic", "urban"] },
  { url: "https://images.unsplash.com/photo-1582005450386-52b25f82d9bb?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["team", "startup", "office", "laptop"] },
  { url: "https://images.unsplash.com/photo-1551434678-e076c223a692?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["work", "desk", "coding", "focus"] },
  { url: "https://images.unsplash.com/photo-1554672408-730436b60dde?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["hand", "phone", "app", "closeup"] },
  { url: "https://images.unsplash.com/photo-1423784346385-c1d4dac9893a?crop=entropy&cs=srgb&fm=jpg&q=85", tags: ["silhouette", "phone", "night", "mood"] },
];

export const pickBrollImages = (terms = [], count = 4) => {
  const lower = terms.map((t) => t.toLowerCase());
  const scored = BROLL_IMAGES.map((img) => ({
    img,
    score: img.tags.filter((tag) => lower.some((t) => t.includes(tag) || tag.includes(t))).length,
  }));
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, count).map((s) => s.img.url);
};
